import React from 'react';
import { FloatButton as AntdFloatButton } from 'antd';
import type { FloatButtonProps } from 'antd';
import {
    getTableButtonType,
    getTypeButton,
} from '../ButtonFilterAction/_service';
import { useAuthButton } from '@app/hooks/useAuthButton';
import './_style.scss';

export interface CustomFloatButtonProps extends FloatButtonProps {
    buttonType?: string;
    labelButton?: React.ReactNode;
    hasAnimation?: boolean;
}

const ScFloatButton: React.FC<CustomFloatButtonProps> = (props) => {
    const {
        buttonType,
        labelButton,
        tooltip,
        icon,
        type = 'primary',
        hasAnimation,
        className,
        ...rest
    } = props;
    const isAuth = useAuthButton(buttonType);

    const animationClass = hasAnimation ? 'sc-float-btn-animated' : '';
    const combinedClassName = className ? `${className} ${animationClass}` : animationClass;

    let iconNode = icon;
    if (!iconNode && buttonType) {
        // Try getting icon from getTableButtonType first
        const classButton = getTableButtonType(buttonType);
        if (classButton && classButton.icon) {
            iconNode = <i className={classButton.icon} />;
        } else {
            // Fallback to getTypeButton
            const classButtonIcon = getTypeButton(buttonType);
            if (classButtonIcon) {
                iconNode = <i className={classButtonIcon} />;
            }
        }
    }

    if (!isAuth) {
        return null;
    }

    return (
        <AntdFloatButton
            className={combinedClassName}
            type={type}
            icon={iconNode}
            tooltip={tooltip || labelButton}
            {...rest}
        />
    );
};

export default ScFloatButton;
